import { Geolocation } from "@capacitor/geolocation";
import { isNative } from "./platform";

// Posizione utente (una tantum). Ritorna {lat,lng,accuracy} o null.
// Nativo: usa il GPS via plugin con richiesta permessi. Web: navigator.geolocation.
export async function getCurrentPosition({ highAccuracy = false, timeout = 8000 } = {}) {
  if (isNative()) {
    try {
      let perm = await Geolocation.checkPermissions();
      if (perm.location !== "granted" && perm.coarseLocation !== "granted") {
        perm = await Geolocation.requestPermissions();
      }
      if (perm.location !== "granted" && perm.coarseLocation !== "granted") return null;
      const p = await Geolocation.getCurrentPosition({ enableHighAccuracy: highAccuracy, timeout });
      return { lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy };
    } catch (e) { return null; }
  }
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy }),
      () => resolve(null),
      { enableHighAccuracy: highAccuracy, timeout, maximumAge: 300000 }
    );
  });
}

// Osservazione posizione (foreground). Ritorna una funzione di stop.
// NB: il tracking rider CONTINUO in background sara' gestito separatamente in una fase dedicata.
export async function watchPosition(cb, { highAccuracy = true } = {}) {
  if (isNative()) {
    let id;
    try {
      const perm = await Geolocation.requestPermissions();
      if (perm.location !== "granted" && perm.coarseLocation !== "granted") return () => {};
      id = await Geolocation.watchPosition({ enableHighAccuracy: highAccuracy }, (p) => {
        if (p) cb({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy });
      });
    } catch (e) { return () => {}; }
    return () => { try { Geolocation.clearWatch({ id }); } catch (e) {} };
  }
  if (!navigator.geolocation) return () => {};
  const id = navigator.geolocation.watchPosition(
    (p) => cb({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy }),
    () => {}, { enableHighAccuracy: highAccuracy }
  );
  return () => navigator.geolocation.clearWatch(id);
}
